// BARBA
// import initBarba from './barba-views/barba.js';

// DOCUMENT
import Document from './helpers/Document.js';

// FACTORY
import ModuleFactory from './factories/ModuleFactory.js';

// COMPONENTS
import ImageWrapper from './components/ImageWrapper.js';
import Modal from './components/Modal.js';
import FilterGroupToggle from './components/FilterGroupToggle.js';
import ProductFilters from './components/ProductFilters.js';

// WEB COMPONENTS
import './web-components/lottie-transition/lottie-transition.js';
import './web-components/split-text/split-text.js';
import './web-components/parallax-el/parallax-el.js';

class App {
    constructor() {
        this.moduleFactory = null;
        this.instances = []; // For starter modules
        this.componentInstances = []; // Store component instances
    }

    init() {
        // 1. Globals
        Document.init();

        // 2. Init Factory (Custom Modules via data-component)
        this.moduleFactory = new ModuleFactory(this); // Pass 'this' (App instance)
        this.moduleFactory.init();

        // 3. Legacy / Starter Modules (Keep existing array logic for these)
        this.initStarterModules();
        this.initComponents();

        // BARBA
        // initBarba(false);
    }

    initComponents() {
        const components = [
            ['.image-wrapper', ImageWrapper],
            ['.js-panel', Modal],
            ['.product-cards, .article-cards, .resource-cards', FilterGroupToggle],
            ['.product-cards', ProductFilters],
        ];

        this.initElementsInDomOrder(components);
    }

    initStarterModules() {
        // Keep your existing logic/array for starter modules here
        const modules = [];
        this.initElementsInDomOrder(modules);
    }

    /**
     * Initialize elements in DOM order
     * @param {Array} elementMappings - Array of [selector, Constructor] pairs
     */
    initElementsInDomOrder(elementMappings) {
        // Collect all elements that need to be initialized
        const elementsToInitialize = [];

        elementMappings.forEach(([selector, Constructor]) => {
            document.querySelectorAll(selector).forEach((element) => {
                elementsToInitialize.push({
                    element,
                    Constructor,
                });
            });
        });

        // Sort elements by their position in the DOM
        elementsToInitialize.sort((a, b) => {
            const position = a.element.compareDocumentPosition(b.element);

            if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
                return -1;
            }
            return 1;
        });

        // Initialize components in DOM order
        elementsToInitialize.forEach(({ element, Constructor }) => {
            if (!Constructor.key) {
                throw new Error(
                    `Constructor key is missing in ${Constructor.name}. Add "static key = 'ClassName';" to the constructor.`
                );
            }
            if (!element.instances) {
                element.instances = {};
            }
            if (!element.instances[Constructor.key]) {
                element.instances[Constructor.key] = new Constructor(element, this);
            }
        });
    }

    // eslint-disable-next-line no-unused-vars
    destroyInstances(container) {
        // console.log('destroyInstances', container);
    }
}

export default new App();
